"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get down () {
        return down;
    },
    get up () {
        return up;
    }
});
const _globals = require("~/utils/globals");
const up = async (knex)=>{
    await knex.schema.alterTable(_globals.MetaTableOldV2.WORKFLOWS, (table)=>{
        table.dropColumn('trigger_count');
        table.text('draft');
    });
};
const down = async (knex)=>{
    await knex.schema.alterTable(_globals.MetaTableOldV2.WORKFLOWS, (table)=>{
        table.integer('trigger_count').defaultTo(0);
        table.dropColumn('draft');
    });
};
